<template>
  <div class="subscriptionModalSuccess">
    <SubscriptionModalHeader @closeModal="closeModal" />
    <div class="subscriptionModalSuccess__body">
      <SubscriptionModalTemporaryBadge />
      <!-- <div class="subscriptionModalSuccess__status">
        <div class="subscriptionModalSuccess__status__checkmark">
          <IconCheck />
        </div>
        <div class="subscriptionModalSuccess__status__text">Subscription successful!</div>
      </div> -->
      <div class="subscriptionModalSuccess__content">
        <h2 class="subscriptionModalSuccess__title">Welcome to Cofocus Premium!</h2>
        <div class="subscriptionModalSuccess__description">
          Here's a shiny badge for you as a thank you note for becoming a subscriber and supporting Cofocus!
        </div>
        <div class="subscriptionModalSuccess__signature">Happy Sessioning!</div>
        <div class="subscriptionModalSuccess__signature">Yours truly,</div>
        <div class="subscriptionModalSuccess__signature" style="margin-top: 0px">Robert & Ness, co-founders of Cofocus</div>
      </div>
    </div>
    <ELYXButton @click="closeModal">Continue</ELYXButton>
  </div>
</template>

<script>
import ELYXButton from "../../ELYXComponents/ELYXButton.vue";
import SubscriptionModalHeader from "./SubscriptionModalHeader.vue";
/* import SubscriptionModalBadge from "./SubscriptionModalBadge.vue"; */
import SubscriptionModalTemporaryBadge from "./SubscriptionModalTemporaryBadge.vue";
/* import IconCheck from "../../ELYXIcons/IconCheck.vue"; */
import confetti from "canvas-confetti";
import { ELYXCentralStore } from "../ELYXStore";

export default {
  components: {
    ELYXButton,
/*     IconCheck, */
    SubscriptionModalHeader,
    SubscriptionModalTemporaryBadge,
    /*     SubscriptionModalBadge, */
  },
  mounted() {
    this.createConfetti();
  },
  methods: {
    createConfetti() {
      var count = 400;
      var defaults = {
        origin: { y: 0.7 },
        zIndex: 10001,
      };

      function fire(particleRatio, opts) {
        confetti(
          Object.assign({}, defaults, opts, {
            particleCount: Math.floor(count * particleRatio),
          })
        );
      }

      fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      fire(0.2, {
        spread: 60,
      });
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });
    },
    closeModal: ELYXCentralStore.methods.closeModal,
  },
};
</script>

<style scoped>
.subscriptionModalSuccess {
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  padding: 15px;
  width: 100%;
  max-width: 465px;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  border-radius: 14px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
/* styles applied when viewport width is 600px or less */
@media (max-width: 500px) {
  .subscriptionModalSuccess {
    max-width: unset;
    width: 100vw;
    border-radius: 0px;
  }
}

/* styles applied when viewport height is 900px or less */
@media (max-height: 625px) {
  .subscriptionModalSuccess {
    height: 100vh;
    overflow-y: scroll;
    border-radius: 0px;
  }
}
.subscriptionModalSuccess__body {
  display: flex;
  flex-direction: column;
  margin: 15px auto;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  padding: 28px;
  padding-top: 23px;
  padding-bottom: 18px;
  background: #ffffffa3;
  width: 100%;
  box-sizing: border-box;
}
.subscriptionModalSuccess__status {
  display: flex;
  align-items: center;
  margin: 15px auto;
  margin-top: 23px;
  margin-bottom: -5px;
  background-color: #ddff5a;
  background-color: #efefef;
  /* background-color: #f1f1f1; */
  border-radius: 360px;
  padding: 2px 3px;
  padding-right: 8px;
}
.subscriptionModalSuccess__status__text {
  font-weight: 600;
  font-size: 14px;
}
.subscriptionModalSuccess__status__checkmark {
  width: 9px;
  height: 9px;
  margin-right: 6px;
  /* background-color: #1cc173; */
  /* background-color: #3dcc89; */
  /* background-color: #46c086; */
  background-color: white;
  border-radius: 360px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.subscriptionModalSuccess__title {
  margin: 15px 0;
  margin-bottom: 10px;
  font-size: 19px;
  color: black;
  font-weight: 600;
  text-align: center;
  line-height: 35px;
}
.subscriptionModalSuccess__description {
  line-height: 35px;
  font-family: "Square Peg";
  font-size: 28px;
}
.subscriptionModalSuccess__signature {
  font-family: "Square Peg";
  font-size: 26px;
  line-height: 35px;
  margin-top: 15px;
}
</style>
